/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import {useAccordionById} from '@amblique/contentful/app/contentful/hooks/use-accordion';
import {useAccordionPanelById} from '@amblique/contentful/app/contentful/hooks/use-accordion-panel';
import {useActionLinksById} from '@amblique/contentful/app/contentful/hooks/use-action-links';
import {useAuthorById} from '@amblique/contentful/app/contentful/hooks/use-author';
import {useBlogById} from '@amblique/contentful/app/contentful/hooks/use-blog';
import {useBlogCategoryById} from '@amblique/contentful/app/contentful/hooks/use-blog-category';
import {useBlogGridById} from '@amblique/contentful/app/contentful/hooks/use-blog-grid';
import {useBreadcrumbById} from '@amblique/contentful/app/contentful/hooks/use-breadcrumb';
import {useCardById} from '@amblique/contentful/app/contentful/hooks/use-card';
import {useCarouselById} from '@amblique/contentful/app/contentful/hooks/use-carousel';
import {useCarouselItemById} from '@amblique/contentful/app/contentful/hooks/use-carousel-item';
import {useContainerById} from '@amblique/contentful/app/contentful/hooks/use-container';
import {useEditorialCopyById} from '@amblique/contentful/app/contentful/hooks/use-editorial-copy';
import {useEmbedPanelById} from '@amblique/contentful/app/contentful/hooks/use-embed-panel';
import {useFeatureBlockById} from '@amblique/contentful/app/contentful/hooks/use-feature-block';
import {useFeatureListById} from '@amblique/contentful/app/contentful/hooks/use-feature-list';
import {useFooterById} from '@amblique/contentful/app/contentful/hooks/use-footer';
import {useFooterColumnById} from '@amblique/contentful/app/contentful/hooks/use-footer-column';
import {useFormBlockCf058ById} from '@amblique/contentful/app/contentful/hooks/use-form-block-cf058';
import {useGlobalConfigById} from '@amblique/contentful/app/contentful/hooks/use-global-config';
import {useHeaderById} from '@amblique/contentful/app/contentful/hooks/use-header';
import {useHeroBannerById} from '@amblique/contentful/app/contentful/hooks/use-hero-banner';
import {useIconById} from '@amblique/contentful/app/contentful/hooks/use-icon';
import {useIconSetById} from '@amblique/contentful/app/contentful/hooks/use-icon-set';
import {useImageById} from '@amblique/contentful/app/contentful/hooks/use-image';
import {useKingDifferenceBlockById} from '@amblique/contentful/app/contentful/hooks/use-king-difference-block';
import {useLinkById} from '@amblique/contentful/app/contentful/hooks/use-link';
import {useMediaCarouselById} from '@amblique/contentful/app/contentful/hooks/use-media-carousel';
import {useMenuItemById} from '@amblique/contentful/app/contentful/hooks/use-menu-item';
import {useNavigationColumnById} from '@amblique/contentful/app/contentful/hooks/use-navigation-column';
import {useNavigationMenuById} from '@amblique/contentful/app/contentful/hooks/use-navigation-menu';
import {useNewBlogPostById} from '@amblique/contentful/app/contentful/hooks/use-new-blog-post';
import {usePageById} from '@amblique/contentful/app/contentful/hooks/use-page';
import {usePageContentById} from '@amblique/contentful/app/contentful/hooks/use-page-content';
import {useProductDetailById} from '@amblique/contentful/app/contentful/hooks/use-product-detail';
import {useProductListingById} from '@amblique/contentful/app/contentful/hooks/use-product-listing';
import {usePromoBannerById} from '@amblique/contentful/app/contentful/hooks/use-promo-banner';
import {usePromoBannerItemById} from '@amblique/contentful/app/contentful/hooks/use-promo-banner-item';
import {useRichTextBlockById} from '@amblique/contentful/app/contentful/hooks/use-rich-text-block';
import {useSearchById} from '@amblique/contentful/app/contentful/hooks/use-search';
import {useSectionPanelById} from '@amblique/contentful/app/contentful/hooks/use-section-panel';
import {useSectionPanelAldrinById} from '@amblique/contentful/app/contentful/hooks/use-section-panel-aldrin';
import {useSeoById} from '@amblique/contentful/app/contentful/hooks/use-seo';
import {useShopTheLookById} from '@amblique/contentful/app/contentful/hooks/use-shop-the-look';
import {useShopTheLookCustomById} from '@amblique/contentful/app/contentful/hooks/use-shop-the-look-custom';
import {useShowroomDetailsById} from '@amblique/contentful/app/contentful/hooks/use-showroom-details';
import {useSplitPanelById} from '@amblique/contentful/app/contentful/hooks/use-split-panel';
import {useSplitPanelDoubleImageBlockById} from '@amblique/contentful/app/contentful/hooks/use-split-panel-double-image-block';
import {useSplitTextById} from '@amblique/contentful/app/contentful/hooks/use-split-text';
import {useSupportBlockById} from '@amblique/contentful/app/contentful/hooks/use-support-block';
import {useTeaserTileById} from '@amblique/contentful/app/contentful/hooks/use-teaser-tile';
import {useTeaserTileBlockById} from '@amblique/contentful/app/contentful/hooks/use-teaser-tile-block';
import {useTemplateStar1ById} from '@amblique/contentful/app/contentful/hooks/use-template-star1';
import {useTileById} from '@amblique/contentful/app/contentful/hooks/use-tile';
import {useUgcBlockById} from '@amblique/contentful/app/contentful/hooks/use-ugc-block';
import {useVideoById} from '@amblique/contentful/app/contentful/hooks/use-video';

/**
 * Type metadata map
 * Contains field names and hooks for each content type
 *
 * @typedef {Object} TypeMetadata
 * @property {string[]} fields - Array of field names for completeness checking
 * @property {Function} hook - React Query hook for fetching full data (useXById)
 *
 * @type {Record<string, TypeMetadata>}
 */
export const CONTENTFUL_METADATA = {
  Accordion: {
    fields: ['body', 'sortOrder', 'sys', 'title'],
    hook: useAccordionById,
  },
  AccordionPanel: {
    fields: ['accordionsCollection', 'media', 'sys', 'title'],
    hook: useAccordionPanelById,
  },
  ActionLinks: {
    fields: ['description', 'displayStyle', 'linksCollection', 'sys', 'title'],
    hook: useActionLinksById,
  },
  Author: {
    fields: ['bio', 'blogAuthorPhoto', 'name', 'sys'],
    hook: useAuthorById,
  },
  Blog: {
    fields: ['author', 'blogCategory', 'blogContent', 'blogHeaderMedia', 'blogTileImage', 'datePublished', 'description', 'duration', 'shareThisPostCollection', 'sys', 'title', 'url'],
    hook: useBlogById,
  },
  BlogCategory: {
    fields: ['description', 'name', 'parentCategory', 'slug', 'sys'],
    hook: useBlogCategoryById,
  },
  BlogGrid: {
    fields: ['appearance', 'blogSummaryCollection', 'cta', 'description', 'sys', 'title'],
    hook: useBlogGridById,
  },
  Breadcrumb: {
    fields: ['jsonData', 'sys', 'title'],
    hook: useBreadcrumbById,
  },
  Card: {
    fields: ['badge', 'badgeStyle', 'category', 'customImage', 'description', 'lifestyleImage', 'primaryImage', 'productId', 'showColorOptions', 'showSizeOptions', 'sys', 'title'],
    hook: useCardById,
  },
  Carousel: {
    fields: ['blogTags', 'categoryId', 'description', 'einsteinRecommenderId', 'heading', 'productIds', 'sys', 'title', 'viewAllLink'],
    hook: useCarouselById,
  },
  CarouselItem: {
    fields: ['appearance', 'media', 'sys', 'text1', 'text2', 'text3', 'text4', 'title'],
    hook: useCarouselItemById,
  },
  Container: {
    fields: ['fullWidth', 'region1Collection', 'sys', 'title'],
    hook: useContainerById,
  },
  EditorialCopy: {
    fields: ['editorialCopy', 'sys'],
    hook: useEditorialCopyById,
  },
  EmbedPanel: {
    fields: ['height', 'htmlContent', 'iframeUrl', 'scriptContent', 'separator', 'sys', 'title', 'width'],
    hook: useEmbedPanelById,
  },
  FeatureBlock: {
    fields: ['chooseContentsCollection', 'sys'],
    hook: useFeatureBlockById,
  },
  FeatureList: {
    fields: ['columns', 'features', 'sys', 'title'],
    hook: useFeatureListById,
  },
  Footer: {
    fields: ['aboutUs', 'columnsCollection', 'countriesCollection', 'legalText', 'logo', 'paymentsCollection', 'region', 'siteId', 'siteNotes', 'socialLinksCollection', 'sys'],
    hook: useFooterById,
  },
  FooterColumn: {
    fields: ['linksCollection', 'sys', 'title'],
    hook: useFooterColumnById,
  },
  FormBlockCf058: {
    fields: ['form', 'heading', 'sys'],
    hook: useFormBlockCf058ById,
  },
  GlobalConfig: {
    fields: ['accountHero', 'availableRegions', 'cartPaymentIconsCollection', 'countriesCollection', 'pdpPreferences', 'showroomFooter', 'showroomHero', 'signUpHeader', 'signUpImage', 'siteId', 'siteName', 'socialLinksCollection', 'sys'],
    hook: useGlobalConfigById,
  },
  Header: {
    fields: ['logo', 'mainNavigation', 'promoBannersCollection', 'siteId', 'sys', 'title', 'utilityLinksCollection'],
    hook: useHeaderById,
  },
  HeroBanner: {
    fields: ['appearance', 'backgroundMedia', 'body', 'cta', 'headingTitle', 'rightCta', 'subtitle', 'sys', 'title', 'underlay'],
    hook: useHeroBannerById,
  },
  Icon: {
    fields: ['description', 'iconImage', 'link', 'mediaType', 'name', 'svgCode', 'sys', 'title'],
    hook: useIconById,
  },
  IconSet: {
    fields: ['iconsCollection', 'sys', 'title'],
    hook: useIconSetById,
  },
  Image: {
    fields: ['alignment', 'altText', 'description', 'desktopAsset', 'fit', 'focus', 'format', 'height', 'mobileAsset', 'openInNewTab', 'quality', 'sys', 'tabletAsset', 'title', 'url', 'width'],
    hook: useImageById,
  },
  KingDifferenceBlock: {
    fields: ['content', 'heading', 'subHeading', 'sys'],
    hook: useKingDifferenceBlockById,
  },
  Link: {
    fields: ['action', 'helptext', 'iconPosition', 'image', 'openInNewTab', 'popupContent', 'sys', 'text', 'totalCount', 'type', 'url'],
    hook: useLinkById,
  },
  MediaCarousel: {
    fields: ['appearance', 'autoPlay', 'body', 'description', 'imagesCollection', 'options', 'presets', 'sys', 'thumbnailsCollection', 'title', 'type'],
    hook: useMediaCarouselById,
  },
  MenuItem: {
    fields: ['featuredLink', 'imagesCollection', 'link', 'submenuCollection', 'sys', 'title', 'type'],
    hook: useMenuItemById,
  },
  NavigationColumn: {
    fields: ['headerText', 'linksCollection', 'sys', 'title'],
    hook: useNavigationColumnById,
  },
  NavigationMenu: {
    fields: ['menuItemsCollection', 'sys', 'title'],
    hook: useNavigationMenuById,
  },
  NewBlogPost: {
    fields: ['author', 'body', 'categories', 'featureImage', 'publishDate', 'relatedPostsCollection', 'seo', 'seoDescription', 'seoTitle', 'slug', 'summary', 'sys', 'tags', 'title'],
    hook: useNewBlogPostById,
  },
  Page: {
    fields: ['categoryId', 'mainRegionCollection', 'productId', 'regions', 'seo', 'slug', 'storeId', 'sys', 'title'],
    hook: usePageById,
  },
  PageContent: {
    fields: ['bottomContentBlocksCollection', 'sys', 'title', 'topContentBlocksCollection'],
    hook: usePageContentById,
  },
  ProductDetail: {
    fields: ['sys', 'title'],
    hook: useProductDetailById,
  },
  ProductListing: {
    fields: ['sys', 'title'],
    hook: useProductListingById,
  },
  PromoBanner: {
    fields: ['backgroundColor', 'itemsCollection', 'sys', 'title'],
    hook: usePromoBannerById,
  },
  PromoBannerItem: {
    fields: ['link', 'promotionText', 'sys', 'textColor', 'title'],
    hook: usePromoBannerItemById,
  },
  RichTextBlock: {
    fields: ['alignment', 'animation', 'content', 'image', 'quote', 'sys', 'title'],
    hook: useRichTextBlockById,
  },
  Search: {
    fields: ['articleTags', 'popularSearches', 'sys', 'title', 'trendingProductIds'],
    hook: useSearchById,
  },
  SectionPanel: {
    fields: ['appearance', 'contentCollection', 'paddingBottom', 'paddingTop', 'sys', 'title'],
    hook: useSectionPanelById,
  },
  SectionPanelAldrin: {
    fields: ['appearance', 'contentCollection', 'paddingBottom', 'paddingTop', 'sys', 'title'],
    hook: useSectionPanelAldrinById,
  },
  Seo: {
    fields: ['description', 'keywords', 'ogImage', 'sys', 'title'],
    hook: useSeoById,
  },
  ShopTheLook: {
    fields: ['hotspots', 'hotspotsContentCollection', 'imageUrl', 'sys', 'title', 'type'],
    hook: useShopTheLookById,
  },
  ShopTheLookCustom: {
    fields: ['content', 'hotspots', 'productId', 'sys', 'title'],
    hook: useShopTheLookCustomById,
  },
  ShowroomDetails: {
    fields: ['contactFormDescription', 'countries', 'description', 'featuredImage', 'headerBlock', 'name', 'onDisplayCollection', 'parkingAddress', 'relatedPages', 'seo', 'storeId', 'storeImages', 'supportBlock', 'sys', 'wheelchairAccessible'],
    hook: useShowroomDetailsById,
  },
  SplitPanel: {
    fields: ['leftContent', 'ratio', 'rightContent', 'style', 'sys', 'title'],
    hook: useSplitPanelById,
  },
  SplitPanelDoubleImageBlock: {
    fields: ['contentCollection', 'mediaPosition', 'primaryImage', 'sys', 'title'],
    hook: useSplitPanelDoubleImageBlockById,
  },
  SplitText: {
    fields: ['headingLeftSize', 'headingRightFontSize', 'sys', 'textLeft', 'textRight'],
    hook: useSplitTextById,
  },
  SupportBlock: {
    fields: ['actionsCollection', 'description', 'image', 'sys', 'title'],
    hook: useSupportBlockById,
  },
  TeaserTile: {
    fields: ['descriptionCollection', 'image', 'overlayIcon', 'sys', 'teaserText', 'title'],
    hook: useTeaserTileById,
  },
  TeaserTileBlock: {
    fields: ['appearance', 'sys', 'teaserTilesCollection', 'title'],
    hook: useTeaserTileBlockById,
  },
  TemplateStar1: {
    fields: ['sys', 'template1'],
    hook: useTemplateStar1ById,
  },
  Tile: {
    fields: ['description', 'image', 'sys', 'title'],
    hook: useTileById,
  },
  UgcBlock: {
    fields: ['bannerId', 'sys', 'title'],
    hook: useUgcBlockById,
  },
  Video: {
    fields: ['options', 'presets', 'sys', 'title', 'videoAsset', 'videoIdOrUrl'],
    hook: useVideoById,
  },
};
